module.exports = __webpack_public_path__ + "static/media/slide-img-1.236a9fa9.png";